module.exports = require("./tr-CY.js");